import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  TextField,
} from "@mui/material";

const CommitOrderModal = ({ open, handleClose, handleSubmit }) => {
  const [formData, setFormData] = useState({
    price: "",
  });

  const initialFormData = {
    price: "",
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const onSubmit = (e) => {
    e.preventDefault();
    handleSubmit(formData);
    setFormData(initialFormData);
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogContent>
        <form onSubmit={onSubmit}>
          <Typography variant="h3">Commit Order</Typography>
          <div>
            <TextField
              id="price"
              label="Price"
              name="price"
              variant="outlined"
              type="number"
              fullWidth
              value={formData.price}
              onChange={(e) => handleChange(e)}
            />
          </div>
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button type="submit" onClick={onSubmit}>
          Commit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CommitOrderModal;
